import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Link2, Copy, Check, Mail } from "lucide-react";

export default function ClientInviteLink() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/inviter/${user.id}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    toast.success("Lien copié — envoyez-le à vos clients !");
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="mb-8 border-2 border-[#FF4D00] bg-white" data-testid="client-invite-link-card">
      <div className="px-6 py-4 flex flex-wrap items-center gap-4">
        <div className="w-10 h-10 bg-[#FF4D00] flex items-center justify-center shrink-0">
          <Link2 className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-[220px]">
          <div className="display text-xl">Mon lien client</div>
          <div className="text-xs text-zinc-600">
            Envoyez ce lien à vos clients : leur demande vous invite automatiquement, et leur paiement est séquestré. Zéro impayé.
          </div>
        </div>
        <div className="flex items-center gap-2 w-full lg:w-auto">
          <input
            readOnly
            value={link}
            onFocus={(e) => e.target.select()}
            className="flex-1 lg:w-72 border-2 border-zinc-300 px-3 py-2 text-xs mono bg-zinc-50"
            data-testid="client-invite-link-input"
          />
          <button onClick={copy} className="btn-anthracite text-xs flex items-center gap-1.5 shrink-0" data-testid="client-invite-link-copy">
            {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
            {copied ? "Copié !" : "Copier"}
          </button>
          <button
            onClick={() => nav("/invitations")}
            className="btn-batisur text-xs flex items-center gap-1.5 shrink-0"
            data-testid="client-invite-email-btn"
          >
            <Mail className="w-3.5 h-3.5" /> Inviter par email
          </button>
        </div>
      </div>
    </div>
  );
}
